import { IDefectiveItemListVM } from '../../models/response/IDefectiveItemResponse';

const initialDefectiveItemState: IDefectiveItemListVM = {
  PagingDetails: {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
  },
  Items: [],
};

export default initialDefectiveItemState;
